// import React, { useState, useEffect, useContext } from "react";
// import { MdUpdate } from "react-icons/md";
// import { RadioTower } from "lucide-react";
// import styled, { keyframes, css } from "styled-components";
// import { formatDate } from "../utils/utils.js";
// import { GlobalState } from "../../GlobalState";
// import Tooltip from "../utils/Tooltip";

// const ripple = keyframes`
//   0% { box-shadow: 0 0 0px 0px rgba(0, 200, 0, 0.5); }
//   100% { box-shadow: 0 0 0px 14px rgba(0, 200, 0, 0); }
// `;

// const pulse = keyframes`
//   0% { opacity: 0.6; }
//   50% { opacity: 1; }
//   100% { opacity: 0.6; }
// `;

// const AnimatedIconWrapper = styled.div`
//   display: inline-flex;
//   justify-content: center;
//   align-items: center;
//   border-radius: 50%;
//   width: 28px;   
//   height: 28px;  
//   position: relative;

//   ${({ online }) =>
//     online
//       ? css`
//           &::after {
//             content: "";
//             position: absolute;
//             top: -2px;
//             left: -2px;
//             width: calc(100% + 4px);
//             height: calc(100% + 4px);
//             border-radius: 50%;
//             animation: ${ripple} 1.5s infinite;
//           }
//         `
//       : css`
//           &::after {
//             content: "";
//             position: absolute;
//             top: -2px;
//             left: -2px;
//             width: calc(100% + 4px);
//             height: calc(100% + 4px);
//             border-radius: 50%;
//             background-color: rgba(255, 0, 0, 0.1); /* red glow */
//           }
//         `}
// `;

// const blinkingRed = keyframes`
//   0% { opacity: 1; }
//   50% { opacity: 0.3; }
//   100% { opacity: 1; }
// `;

// const BlinkingRadioTower = styled(RadioTower)`
//   color: red;
//   animation: ${blinkingRed} 2s infinite;
// `;

// const AnimatedIcon = styled(RadioTower)`
//   width: 16px;
//   height: 16px;
//   ${({ online }) =>
//     online &&
//     css`
//       animation: ${pulse} 1.5s infinite;
//       color: green;
//     `}
// `;

// const Container = styled.div`
//   border-radius: 15px;
//   padding: 0.5rem;
//   margin: 0.25rem;
//   display: flex;
//   gap: 0.5rem;
//   flex-direction: column;
//   min-width: 240px;
//   word-wrap: break-word;
//   overflow-wrap: break-word;
//   white-space: normal;
// `;

// const TopLine = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: flex-start;  // important so timestamp stays top-aligned
//   width: 100%;
//   gap: 0.5rem;
// `;

// const LeftGroup = styled.div`
//   display: flex;
//   align-items: flex-start;
//   gap: 0.5rem;
//   flex: 1;
// `;

// const LocationName = styled.h5`
//   margin: 0;
//   word-wrap: break-word;
//   white-space: normal;   // allows wrapping
//   overflow-wrap: break-word;
//   max-width: 180px;
// `;

// const TimeElapsed = styled.p`
//   margin: 0;
//   font-size: 0.75rem;
//   font-weight: 500;
//   color: #555;
//   display: flex;
//   align-items: center;
//   flex-shrink: 0;   // prevent timestamp from shrinking
// `;

// export default function GatewayBoxComponent({ sensor }) {
//   const [gatewayData, setGatewayData] = useState(sensor || {});
//   const state = useContext(GlobalState);   
//   const token = state?.token?.[0];         

//   const fetchGatewayData = async () => {
//     if (!sensor?.gateway_id || !token) return;

//     try {
//       const res = await fetch(
//         `${process.env.REACT_APP_API}/sensor/gateway?gateway_id=${sensor.gateway_id}`,
//         {
//           headers: { Authorization: state.token[0] },
//         }
//       );
//       const json = await res.json();
//       if (json.data) setGatewayData(json.data);
//     } catch (err) {
//       console.error("Error fetching gateway data:", err);
//     }
//   };

//   useEffect(() => {
//     if (!sensor?.gateway_id) return;
//     fetchGatewayData();
//     const interval = setInterval(fetchGatewayData, 5000);
//     return () => clearInterval(interval);
//   }, [sensor?.gateway_id, token]);

//   const { gateway_online, updatedAt, location_name } = gatewayData;
//   if (!location_name) return <Container>Loading...</Container>;

//   return (
//     <Container>
//       <TopLine>
//         <LeftGroup>
//           <AnimatedIconWrapper online={gateway_online}>
//             {gateway_online ? (
//               <AnimatedIcon online size={16} strokeWidth={2} />
//             ) : (
//               <BlinkingRadioTower size={20} strokeWidth={2} color="red" />
//             )}
//           </AnimatedIconWrapper>
//           <LocationName>{location_name}</LocationName>
//         </LeftGroup>

//         <TimeElapsed>
//           {/* <MdUpdate style={{ marginRight: "4px" }} /> */}
//           {formatDate(updatedAt)}
//         </TimeElapsed>
//       </TopLine>
//     </Container>
//   );
// }

// import React, { useState, useEffect, useContext } from "react";
// import styled, { keyframes, css } from "styled-components";
// import { GlobalState } from "../../GlobalState";

// const Container = styled.div`
//   border-radius: 20px;  
//   display: flex;
//   flex-direction: column;
//   padding: 0.5rem;
//   position: relative;
//   backdrop-filter: blur(2px);
//   min-width: 160px; 

//   @media (max-width: 1024px) {
//     width: 280px;
//     min-width: 280px;
//     max-width: 280px;
//   }

//   @media (max-width: 768px) {
//     width: 100%;
//     min-width: 180px;
//     max-width: 200px;
//     margin: 0 auto;
//   }
// `;

// const TopLine = styled.div`
//   width: 100%;
//   display: flex;
//   align-items: center;     
//   justify-content: space-between; 
//   gap: 10px;
// `;


// const gradientShift = keyframes`
//   0% {
//     background-position: -200% center;
//   }
//   100% {
//     background-position: 200% center;
//   }
// `;

// const pulse = keyframes`
//   0%, 100% { 
//     transform: scale(1);
//   }
//   50% { 
//     transform: scale(1.05);
//   }
// `;

// const LocationName = styled.p`
//   margin: 0;
//   opacity: 0;
//   animation: fadeIn 0.4s ease forwards, ${gradientShift} 2.5s linear infinite, ${pulse} 2s ease-in-out infinite;
//   font-weight: 1000;
//   white-space: nowrap;
//   font-size: 0.9rem;

//   ${({ $isFaulty, $isOnline }) =>
//     $isFaulty
//       ? css`
//           background: linear-gradient(
//             90deg,
//             #ef4444 0%,
//             #ef4444 30%,
//             #ffeb3b 50%,
//             #ef4444 70%,
//             #ef4444 100%
//           );
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : $isOnline
//       ? css`
//           background: linear-gradient(
//             90deg,
//             #5ca904 0%,
//             #5ca904 30%,
//             #00ffff 50%,
//             #5ca904 70%,
//             #5ca904 100%
//           );
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : css`
//           background: linear-gradient(
//             90deg,
//             #ea580c 0%,
//             #ea580c 30%,
//             #00bfff 50%,
//             #ea580c 70%,
//             #ea580c 100%
//           );
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `}

//   @keyframes fadeIn {
//     to {
//       opacity: 1;
//     }
//   }
// `;

// const StatusBadge = styled.div`
//   padding: 2px 6px;
//   border-radius: 4px;
//   font-size: 0.65rem;
//   font-weight: 700;
//   white-space: nowrap;
//   color: white;
//   background-color: #fb923c;
// `;

// const TimeElapsed = styled.p`
//   margin: 0;
//   font-size: 0.7rem;
//   font-weight: 600;
//   color: #6b7280;
//   white-space: nowrap;
//   opacity: 0.8;
// `;


// export default function GatewayBoxComponent({ sensor }) {
//   const [gatewayData, setGatewayData] = useState(sensor || {});
//   const state = useContext(GlobalState);   
//   const token = state?.token?.[0];         

//   const fetchGatewayData = async () => {
//     if (!sensor?.gateway_id || !token) return;

//     try {
//       const res = await fetch(
//         `${process.env.REACT_APP_API}/sensor/gateway?gateway_id=${sensor.gateway_id}`,
//         { headers: { Authorization: state.token[0] } }
//       );
//       const json = await res.json();
//       if (json.data) setGatewayData(json.data);
//     } catch (err) {
//       console.error("Error fetching gateway data:", err);
//     }
//   };

//   useEffect(() => {
//     if (!sensor?.gateway_id) return;
//     fetchGatewayData();
//     const interval = setInterval(fetchGatewayData, 5000);
//     return () => clearInterval(interval);
//   }, [sensor?.gateway_id, token]);

//   // const { gateway_online, location_name } = gatewayData;
//   const { gateway_online, location_name, updatedAt } = gatewayData;
//   if (!location_name) return <Container>Loading...</Container>;

//   const formatTimeAgo = (date) => {
//   if (!date) return "";
//   const seconds = Math.floor((new Date() - new Date(date)) / 1000);

//   if (seconds < 60) return `${seconds}s ago`;
//   if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
//   if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;

//   return new Date(date).toLocaleDateString();
// };


//   return (
// <Container>
//   <TopLine>
//     <LocationName $isOnline={gateway_online}>
//       {location_name}
//     </LocationName>

//     <TimeElapsed>
//       {formatTimeAgo(updatedAt)}
//     </TimeElapsed>
//   </TopLine>

//   {!gateway_online && <StatusBadge>Offline</StatusBadge>}
// </Container>

//   );
// }

// import React, { useState, useEffect, useContext } from "react";
// import styled, { keyframes, css } from "styled-components";
// import { GlobalState } from "../../GlobalState";
// import { formatDate } from "../utils/utils";

// const Container = styled.div`
//   border-radius: 20px;  
//   display: flex;
//   flex-direction: column;
//   padding: 0.5rem;
//   position: relative;
//   backdrop-filter: blur(2px);
//   min-width: 160px; 

//   @media (max-width: 1024px) {
//     width: 280px;
//     min-width: 280px;
//     max-width: 280px;
//   }

//   @media (max-width: 768px) {
//     width: 100%;
//     min-width: 180px;
//     max-width: 200px;
//     margin: 0 auto;
//   }
// `;

// const TopLine = styled.div`
//   width: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 8px;
// `;

// const gradientShift = keyframes`
//   0% { background-position: -200% center; }
//   100% { background-position: 200% center; }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;

// const LocationName = styled.p`
//   margin: 0;
//   opacity: 0;
//   animation: fadeIn 0.4s ease forwards, ${gradientShift} 2.5s linear infinite, ${pulse} 2s ease-in-out infinite;
//   font-weight: 1000;
//   white-space: nowrap;
//   font-size: 0.9rem;

//   ${({ $isFaulty, $isOnline }) =>
//     $isFaulty
//       ? css`
//           background: linear-gradient(90deg, #ef4444 0%, #ef4444 30%, #ffeb3b 50%, #ef4444 70%, #ef4444 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : $isOnline
//       ? css`
//           background: linear-gradient(90deg, #5ca904 0%, #5ca904 30%, #00ffff 50%, #5ca904 70%, #5ca904 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : css`
//           background: linear-gradient(90deg, #ea580c 0%, #ea580c 30%, #00bfff 50%, #ea580c 70%, #ea580c 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `}

//   @keyframes fadeIn {
//     to { opacity: 1; }
//   }
// `;

// const OfflineBadge = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 5px;
//  background-color: rgba(251, 146, 60, 0.75);
//   color: white;
//   padding: 3px 8px;
//   border-radius: 5px;
//   white-space: nowrap;
//   flex-shrink: 0;

//   .icon {
//     font-size: 0.85rem;
//     line-height: 1;
//   }

//   .timestamp {
//     font-size: 0.72rem;
//     font-weight: 600;
//     letter-spacing: 0.01em;
//   }

//   @media (max-width: 1024px) {
//     padding: 2px 6px;
//     .timestamp { font-size: 0.68rem; }
//   }

//   @media (max-width: 768px) {
//     padding: 2px 5px;
//     .timestamp { font-size: 0.63rem; }
//   }
// `;

// export default function GatewayBoxComponent({ sensor }) {
//   const [gatewayData, setGatewayData] = useState(sensor || {});
//   const state = useContext(GlobalState);
//   const token = state?.token?.[0];

//   const fetchGatewayData = async () => {
//     if (!sensor?.gateway_id || !token) return;

//     try {
//       const res = await fetch(
//         `${process.env.REACT_APP_API}/sensor/gateway?gateway_id=${sensor.gateway_id}`,
//         { headers: { Authorization: state.token[0] } }
//       );
//       const json = await res.json();
//       if (json.data) setGatewayData(json.data);
//     } catch (err) {
//       console.error("Error fetching gateway data:", err);
//     }
//   };

//   useEffect(() => {
//     if (!sensor?.gateway_id) return;
//     fetchGatewayData();
//     const interval = setInterval(fetchGatewayData, 5000);
//     return () => clearInterval(interval);
//   }, [sensor?.gateway_id, token]);

//   const { gateway_online, location_name, updatedAt } = gatewayData;
//   if (!location_name) return <Container>Loading...</Container>;


//   return (
//     <Container>
//       <TopLine>
//         <LocationName $isOnline={gateway_online}>
//           {location_name}
//         </LocationName>

//         {!gateway_online && updatedAt && (
//           <OfflineBadge>
//             <span className="icon">⚠</span>
//             <span className="timestamp">{formatDate(updatedAt)}</span>
//           </OfflineBadge>
//         )}
//       </TopLine>
//     </Container>
//   );
// }




// import React, { useState, useEffect, useContext, useRef } from "react";
// import styled, { keyframes, css } from "styled-components";
// import { GlobalState } from "../../GlobalState";
// import { formatDate } from "../utils/utils";

// const Container = styled.div`
//   border-radius: 20px;  
//   display: flex;
//   flex-direction: column;
//   padding: 0.5rem;
//   position: relative;
//   backdrop-filter: blur(2px);
//   min-width: 160px; 

//   @media (max-width: 1024px) {
//     width: 280px;
//     min-width: 280px;
//     max-width: 280px;
//   }

//   @media (max-width: 768px) {
//     width: 100%;
//     min-width: 180px;
//     max-width: 200px;
//     margin: 0 auto;
//   }
// `;

// const TopLine = styled.div`
//   width: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 8px;
// `;

// const gradientShift = keyframes`
//   0% { background-position: -200% center; }
//   100% { background-position: 200% center; }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;

// const LocationName = styled.p`
//   margin: 0;
//   opacity: 0;
//   animation: fadeIn 0.4s ease forwards, ${gradientShift} 2.5s linear infinite, ${pulse} 2s ease-in-out infinite;
//   font-weight: 1000;
//   white-space: nowrap;
//   font-size: 0.9rem;

//   ${({ $isFaulty, $isOnline }) =>
//     $isFaulty
//       ? css`
//           background: linear-gradient(90deg, #ef4444 0%, #ef4444 30%, #ffeb3b 50%, #ef4444 70%, #ef4444 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : $isOnline
//       ? css`
//           background: linear-gradient(90deg, #5ca904 0%, #5ca904 30%, #00ffff 50%, #5ca904 70%, #5ca904 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : css`
//           background: linear-gradient(90deg, #ea580c 0%, #ea580c 30%, #00bfff 50%, #ea580c 70%, #ea580c 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `}

//   @keyframes fadeIn {
//     to { opacity: 1; }
//   }
// `;

// const OfflineBadge = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   background-color: rgba(251, 146, 60, 0.75);
//   color: white;
//   padding: 3px 8px;
//   border-radius: 5px;
//   white-space: nowrap;
//   flex-shrink: 0;

//   .icon {
//     font-size: 0.85rem;
//     line-height: 1;
//   }

//   .timestamp {
//     font-size: 0.72rem;
//     font-weight: 600;
//     letter-spacing: 0.01em;
//   }

//   @media (max-width: 1024px) {
//     padding: 2px 6px;
//     .timestamp { font-size: 0.68rem; }
//   }

//   @media (max-width: 768px) {
//     padding: 2px 5px;
//     .timestamp { font-size: 0.63rem; }
//   }
// `;

// const TimestampWrapper = styled.div`
//   position: relative;
//   display: inline-flex;
//   align-items: center;

//   .tooltip {
//     position: absolute;
//     bottom: 100%;
//     left: 50%;
//     transform: translateX(-50%) translateY(0px);
//     background: white;
//     color: rgb(204, 72, 77);
//     font-size: 0.7rem;
//     font-weight: 800;
//     padding: 3px 8px;
//     border-radius: 4px;
//     white-space: nowrap;
//     opacity: 0;
//     pointer-events: none;
//     transition: opacity 0.2s ease, transform 0.2s ease;
//     margin-bottom: 6px;
//     z-index: 99;
//     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

//     &::after {
//       content: "";
//       position: absolute;
//       top: 100%;
//       left: 50%;
//       transform: translateX(-50%);
//       border: 4px solid transparent;
//       border-top-color: white;
//     }
//   }

//   &:hover .tooltip {
//     opacity: 1;
//     transform: translateX(-50%) translateY(-4px);
//   }

//   &.touch-active .tooltip {
//     opacity: 1;
//     transform: translateX(-50%) translateY(-4px);
//   }
// `;

// function useTouchTooltip(ref) {
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;

//     let hideTimer;

//     const onTouchStart = (e) => {
//       e.preventDefault();
//       el.classList.add("touch-active");
//       clearTimeout(hideTimer);
//       hideTimer = setTimeout(() => el.classList.remove("touch-active"), 2500);
//     };

//     el.addEventListener("touchstart", onTouchStart, { passive: false });
//     return () => {
//       el.removeEventListener("touchstart", onTouchStart);
//       clearTimeout(hideTimer);
//     };
//   }, [ref]);
// }

// export default function GatewayBoxComponent({ sensor }) {
//   const [gatewayData, setGatewayData] = useState(sensor || {});
//   const state = useContext(GlobalState);
//   const token = state?.token?.[0];

//   const tooltipRef = useRef(null);
//   useTouchTooltip(tooltipRef);

//   const fetchGatewayData = async () => {
//     if (!sensor?.gateway_id || !token) return;

//     try {
//       const res = await fetch(
//         `${process.env.REACT_APP_API}/sensor/gateway?gateway_id=${sensor.gateway_id}`,
//         { headers: { Authorization: state.token[0] } }
//       );
//       const json = await res.json();
//       if (json.data) setGatewayData(json.data);
//     } catch (err) {
//       console.error("Error fetching gateway data:", err);
//     }
//   };

//   useEffect(() => {
//     if (!sensor?.gateway_id) return;
//     fetchGatewayData();
//     const interval = setInterval(fetchGatewayData, 5000);
//     return () => clearInterval(interval);
//   }, [sensor?.gateway_id, token]);

//   const { gateway_online, location_name, updatedAt } = gatewayData;
//   if (!location_name) return <Container>Loading...</Container>;

//   return (
//     <Container>
//       <TopLine>
//         <LocationName $isOnline={gateway_online}>
//           {location_name}
//         </LocationName>

//         {!gateway_online && updatedAt && (
//           <OfflineBadge>
//             <span className="icon">⚠</span>
//             <TimestampWrapper ref={tooltipRef}>
//               <span className="tooltip">⚠ Gateway is offline</span>
//               <span className="timestamp">{formatDate(updatedAt)}</span>
//             </TimestampWrapper>
//           </OfflineBadge>
//         )}
//       </TopLine>
//     </Container>
//   );
// }




// import React, { useState, useEffect, useContext, useRef } from "react";
// import styled, { keyframes, css } from "styled-components";
// import { GlobalState } from "../../GlobalState";
// import { formatDate } from "../utils/utils";

// const Container = styled.div`
//   border-radius: 20px;  
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   padding: 0.5rem;
//   position: relative;
//   backdrop-filter: blur(2px);
//   min-width: 160px;

//   @media (max-width: 1024px) {
//     width: auto;
//     min-width: 0;
//     max-width: 100%;
//   }

//   @media (max-width: 768px) {
//     width: 100%;
//     min-width: 0;
//     max-width: 100%;
//     margin: 0;
//     align-items: center;
//   }
// `;

// const TopLine = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   min-width: 0;
//   flex-wrap: nowrap;

//   @media (max-width: 768px) {
//     justify-content: center;
//     gap: 6px;
//   }
// `;

// const gradientShift = keyframes`
//   0% { background-position: -200% center; }
//   100% { background-position: 200% center; }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;

// const LocationName = styled.p`
//   margin: 0;
//   opacity: 0;
//   animation: fadeIn 0.4s ease forwards, ${gradientShift} 2.5s linear infinite, ${pulse} 2s ease-in-out infinite;
//   font-weight: 1000;
//   white-space: nowrap;
//   font-size: 0.9rem;
//   min-width: 0;
//   overflow: hidden;
//   text-overflow: ellipsis;

//   ${({ $isFaulty, $isOnline }) =>
//     $isFaulty
//       ? css`
//           background: linear-gradient(90deg, #ef4444 0%, #ef4444 30%, #ffeb3b 50%, #ef4444 70%, #ef4444 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : $isOnline
//       ? css`
//           background: linear-gradient(90deg, #5ca904 0%, #5ca904 30%, #00ffff 50%, #5ca904 70%, #5ca904 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : css`
//           background: linear-gradient(90deg, #ea580c 0%, #ea580c 30%, #00bfff 50%, #ea580c 70%, #ea580c 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `}

//   @keyframes fadeIn {
//     to { opacity: 1; }
//   }

//   @media (max-width: 768px) {
//     font-size: 0.82rem;
//   }
// `;

// const OfflineBadge = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   background-color: rgba(251, 146, 60, 0.75);
//   color: white;
//   padding: 3px 8px;
//   border-radius: 5px;
//   white-space: nowrap;
//   flex-shrink: 0;

//   .icon {
//     font-size: 0.85rem;
//     line-height: 1;
//   }

//   .timestamp {
//     font-size: 0.72rem;
//     font-weight: 600;
//     letter-spacing: 0.01em;
//   }

//   @media (max-width: 1024px) {
//     padding: 2px 6px;
//     .timestamp { font-size: 0.68rem; }
//   }

//   @media (max-width: 768px) {
//     padding: 2px 5px;
//     gap: 3px;
//     .timestamp { font-size: 0.63rem; }
//     .icon { font-size: 0.75rem; }
//   }
// `;

// const TimestampWrapper = styled.div`
//   position: relative;
//   display: inline-flex;
//   align-items: center;

//   .tooltip {
//     position: absolute;
//     bottom: 100%;
//     left: 50%;
//     transform: translateX(-50%) translateY(0px);
//     background: white;
//     color: rgb(204, 72, 77);
//     font-size: 0.7rem;
//     font-weight: 800;
//     padding: 3px 8px;
//     border-radius: 4px;
//     white-space: nowrap;
//     opacity: 0;
//     pointer-events: none;
//     transition: opacity 0.2s ease, transform 0.2s ease;
//     margin-bottom: 6px;
//     z-index: 99;
//     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

//     &::after {
//       content: "";
//       position: absolute;
//       top: 100%;
//       left: 50%;
//       transform: translateX(-50%);
//       border: 4px solid transparent;
//       border-top-color: white;
//     }
//   }

//   &:hover .tooltip {
//     opacity: 1;
//     transform: translateX(-50%) translateY(-4px);
//   }

//   &.touch-active .tooltip {
//     opacity: 1;
//     transform: translateX(-50%) translateY(-4px);
//   }
// `;

// function useTouchTooltip(ref) {
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;

//     let hideTimer;

//     const onTouchStart = (e) => {
//       e.preventDefault();
//       el.classList.add("touch-active");
//       clearTimeout(hideTimer);
//       hideTimer = setTimeout(() => el.classList.remove("touch-active"), 2500);
//     };

//     el.addEventListener("touchstart", onTouchStart, { passive: false });
//     return () => {
//       el.removeEventListener("touchstart", onTouchStart);
//       clearTimeout(hideTimer);
//     };
//   }, [ref]);
// }

// export default function GatewayBoxComponent({ sensor }) {
//   const [gatewayData, setGatewayData] = useState(sensor || {});
//   const state = useContext(GlobalState);
//   const token = state?.token?.[0];

//   const tooltipRef = useRef(null);
//   useTouchTooltip(tooltipRef);

//   const fetchGatewayData = async () => {
//     if (!sensor?.gateway_id || !token) return;

//     try {
//       const res = await fetch(
//         `${process.env.REACT_APP_API}/sensor/gateway?gateway_id=${sensor.gateway_id}`,
//         { headers: { Authorization: state.token[0] } }
//       );
//       const json = await res.json();
//       if (json.data) setGatewayData(json.data);
//     } catch (err) {
//       console.error("Error fetching gateway data:", err);
//     }
//   };

//   useEffect(() => {
//     if (!sensor?.gateway_id) return;
//     fetchGatewayData();
//     const interval = setInterval(fetchGatewayData, 5000);
//     return () => clearInterval(interval);
//   }, [sensor?.gateway_id, token]);

//   const { gateway_online, location_name, updatedAt } = gatewayData;
//   if (!location_name) return <Container>Loading...</Container>;

//   return (
//     <Container>
//       <TopLine>
//         <LocationName $isOnline={gateway_online}>
//           {location_name}
//         </LocationName>

//         {!gateway_online && updatedAt && (
//           <OfflineBadge>
//             <span className="icon">⚠</span>
//             <TimestampWrapper ref={tooltipRef}>
//               <span className="tooltip">⚠ Gateway is offline</span>
//               <span className="timestamp">{formatDate(updatedAt)}</span>
//             </TimestampWrapper>
//           </OfflineBadge>
//         )}
//       </TopLine>
//     </Container>
//   );
// }



import React, { useState, useEffect, useContext, useRef } from "react";
import styled, { keyframes, css } from "styled-components";
import { GlobalState } from "../../GlobalState";
import { formatDate } from "../utils/utils";
import { formatOfflineDuration } from "../utils/formatOfflineDuration";

/* Identical to PumpStatusV2/V3/SolenoidBoxComponent's PbBlock */
const PbBlock = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: fit-content;
  min-width: 180px;
  max-width: 340px;
  margin: 0.5rem;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  display: flex;
  transition: all 0.3s ease;

  @media (max-width: 480px) {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
    margin: 0.3rem 0;
  }
`;

const AccentBar = styled.div`
  width: 5px;
  flex-shrink: 0;
  background: ${({ $isOnline }) => ($isOnline ? "#22C55E" : "#94A3B8")};
`;

const PbInner = styled.div`
  flex: 1;
  padding: 4px 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

const PbMeta = styled.div`
  flex: 1;
  min-width: 0;
`;

const LocationName = styled.p`
  margin: 0;
  font-weight: 700;
  white-space: nowrap;
  font-size: 0.85rem;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #111827;

  @media (max-width: 768px) {
    font-size: 0.75rem;
  }
`;

const StatusLine = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  color: ${({ $isOnline }) => ($isOnline ? "#16A34A" : "#9CA3AF")};

  @media (max-width: 768px) {
    font-size: 0.65rem;
  }
`;

const Badge = styled.span`
  font-size: 9.5px;
  font-weight: 500;
  padding: 2px 7px;
  border-radius: 8px;
  white-space: nowrap;
  flex-shrink: 0;
  background: ${({ $isOnline }) =>
    $isOnline ? "rgba(34,197,94,.12)" : "#F3F4F6"};
  color: ${({ $isOnline }) => ($isOnline ? "#15803D" : "#090a0e")};
`;

const BadgeStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.08);
  }
`;

const PlainDuration = styled.span`
  display: inline-block; /* Important */
  font-size: 10px;
  font-weight: 500;
  color: #d81111;
  white-space: nowrap;
  animation: ${pulse} 2s infinite ease-in-out;
  transform-origin: center;
`;

const OfflineBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: rgba(251, 146, 60, 0.5);
  color: rgb(57, 56, 56);
  padding: 3px 8px;
  border-radius: 5px;
  white-space: nowrap;
  width: fit-content;

  .icon {
    font-size: 0.85rem;
    line-height: 1;
  }

  .timestamp {
    font-size: 0.7rem;
    font-family: Arial, sans-serif;
    font-weight: 700;
    letter-spacing: 0.01em;
  }

  @media (max-width: 768px) {
    padding: 2px 5px;
    gap: 3px;
    .timestamp { font-size: 0.65rem; }
    .icon { font-size: 0.65rem; }
  }
`;

const TimestampWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;

  .tooltip {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(0px);
    background: white;
    color: rgb(204, 72, 77);
    font-size: 0.75rem;
    font-weight: 800;
    padding: 4px 10px;
    border-radius: 4px;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease, transform 0.2s ease;
    margin-bottom: 6px;
    z-index: 99;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 4px solid transparent;
      border-top-color: white;
    }
  }

  &:hover .tooltip {
    opacity: 1;
    transform: translateX(-50%) translateY(-4px);
  }

  &.touch-active .tooltip {
    opacity: 1;
    transform: translateX(-50%) translateY(-4px);
  }
`;

/* Robust boolean coercion — handles booleans, "1"/"0", "true"/"false", numbers.
   Boolean("false") is a real trap since any non-empty string is truthy in JS. */
function toBool(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    return v === "1" || v === "true" || v === "on";
  }
  return Boolean(value);
}

function useTouchTooltip(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let hideTimer;

    const onTouchStart = (e) => {
      e.preventDefault();
      el.classList.add("touch-active");
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => el.classList.remove("touch-active"), 2500);
    };

    el.addEventListener("touchstart", onTouchStart, { passive: false });
    return () => {
      el.removeEventListener("touchstart", onTouchStart);
      clearTimeout(hideTimer);
    };
  }, [ref]);
}

export default function GatewayBoxComponent({ sensor }) {
  const [gatewayData, setGatewayData] = useState(sensor || {});
  const state = useContext(GlobalState);
  const token = state?.token?.[0];

  const tooltipRef = useRef(null);
  useTouchTooltip(tooltipRef);

  const fetchGatewayData = async () => {
    if (!sensor?.gateway_id || !token) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}/sensor/gateway?gateway_id=${sensor.gateway_id}`,
        { headers: { Authorization: state.token[0] } }
      );
      const json = await res.json();
      if (json.data) setGatewayData(json.data);
    } catch (err) {
      console.error("Error fetching gateway data:", err);
    }
  };

  useEffect(() => {
    if (!sensor?.gateway_id) return;
    fetchGatewayData();
    const interval = setInterval(fetchGatewayData, 5000);
    return () => clearInterval(interval);
  }, [sensor?.gateway_id, token]);

  const { gateway_online, location_name, updatedAt } = gatewayData;
  const isOnline = toBool(gateway_online);

  const MAX_LENGTH = 15;
  const truncatedLocationName =
    location_name?.length > MAX_LENGTH
      ? location_name.slice(0, MAX_LENGTH)
      : location_name;

  if (!location_name) {
    return (
      <PbBlock>
        <AccentBar $isOnline={false} />
        <PbInner>
          <StatusLine $isOnline={false}>Loading...</StatusLine>
        </PbInner>
      </PbBlock>
    );
  }

  return (
    <PbBlock>
      <AccentBar $isOnline={isOnline} />

      <PbInner>
        <TopRow>
          <PbMeta>
            <LocationName>{truncatedLocationName}</LocationName>
          </PbMeta>

          <BadgeStack>
            <Badge $isOnline={isOnline}>{isOnline ? "online" : "offline"}</Badge>

            {!isOnline && (
              <PlainDuration>
                {formatOfflineDuration(updatedAt)}
              </PlainDuration>
            )}
          </BadgeStack>
        </TopRow>
      </PbInner>
    </PbBlock>
  );
}
